export enum AtiraLinkPlanType {
  PLAN_0 = 'PLAN_0',
  PLAN_1 = 'PLAN_1',
  PLAN_2 = 'PLAN_2',
}
